(function () {
  var root = document.querySelector('[data-sg]');
  if (!root) return;
  var fr = root.dataset.locale === 'fr', base = root.dataset.root || '/';
  var input = root.querySelector('[data-sg-input]'), list = root.querySelector('[data-sg-results]');
  var empty = root.querySelector('[data-sg-empty]'), chart = root.querySelector('[data-sg-chart]');
  var unit = 'cm', data = [], marks = [];
  var T = fr ? {
    fits: 'Plus petite taille assez longue', none: 'Aucun de nos lits n’est assez long pour cette mesure. Écrivez-nous et nous vous aiderons.',
    prompt: 'Entrez une mesure pour voir les tailles qui conviennent.', size: 'taille', unitIn: 'po', dog: 'chien'
  } : {
    fits: 'Smallest size that is long enough', none: 'None of our beds is long enough for this measurement. Contact us and we will help.',
    prompt: 'Enter a measurement to see the sizes that fit.', size: 'size', unitIn: 'in', dog: 'dog'
  };
  var len = function (s) { return Math.max(s.l, s.w); };
  var inch = function (cm) { return Math.round(cm / 2.54); };
  var name = function (p) { return fr ? p.fr : p.en; };
  var url = function (h) { return base.replace(/\/$/, '') + '/products/' + h; };
  var fmt = function (s) { return s.side ? s.l + ' ' + (fr ? 'cm (côté)' : 'cm (side)') : s.l + ' x ' + s.w + ' cm'; };

  function buildChart() {
    var all = [].concat.apply([], data.map(function (p) { return p.sizes.map(len); }));
    var lo = Math.floor(Math.min.apply(null, all) / 10) * 10, hi = Math.ceil((Math.max.apply(null, all) + 5) / 10) * 10;
    var pct = function (v) { return ((v - lo) / (hi - lo)) * 100; };
    var rows = data.slice().sort(function (a, b) { return len(a.sizes[0]) - len(b.sizes[0]); });
    var html = '';
    rows.forEach(function (p) {
      var a = len(p.sizes[0]), b = len(p.sizes[p.sizes.length - 1]);
      var dots = p.sizes.map(function (s) { return '<i class="sg__dot" style="left:' + pct(len(s)) + '%" title="' + s.label + ': ' + fmt(s) + '"></i>'; }).join('');
      html += '<a class="sg__bar" href="' + url(p.handle) + '"><span class="sg__name">' + name(p) + '</span><span class="sg__track">' +
        '<i class="sg__fill" style="left:' + pct(a) + '%;width:' + Math.max(pct(b) - pct(a), 1.5) + '%"></i>' + dots + '<i class="sg__mark"></i></span></a>';
    });
    var ticks = '';
    for (var v = lo; v <= hi; v += 20) ticks += '<span style="left:' + pct(v) + '%">' + v + ' cm<br>' + inch(v) + ' ' + T.unitIn + '</span>';
    html += '<div class="sg__axis"><span class="sg__name"></span><div class="sg__ticks" style="height:34px">' + ticks + '</div></div>';
    chart.innerHTML = html;
    marks = [].slice.call(chart.querySelectorAll('.sg__mark'));
    chart.dataset.lo = lo; chart.dataset.hi = hi;
  }

  function update() {
    var v = parseFloat(input.value);
    var cm = unit === 'in' ? v * 2.54 : v;
    var lo = +chart.dataset.lo, hi = +chart.dataset.hi;
    list.innerHTML = ''; empty.hidden = true;
    marks.forEach(function (m) {
      if (cm >= lo && cm <= hi) { m.style.display = 'block'; m.style.left = ((cm - lo) / (hi - lo)) * 100 + '%'; } else m.style.display = 'none';
    });
    if (!(cm >= 10 && cm <= 250)) { empty.textContent = T.prompt; empty.hidden = false; return; }
    var out = [];
    data.forEach(function (p) {
      var s = p.sizes.filter(function (x) { return len(x) >= cm; })[0];
      if (s) out.push({ p: p, s: s });
    });
    out.sort(function (a, b) { return len(a.s) - len(b.s); });
    if (!out.length) { empty.textContent = T.none; empty.hidden = false; return; }
    out.forEach(function (o) {
      var li = document.createElement('li');
      li.innerHTML = '<a class="sg__res" href="' + url(o.p.handle) + '"><span><b>' + name(o.p) + '</b></span><small>' + (/\d/.test(o.s.label) ? '' : T.size + ' ' + o.s.label.replace(/</g, '') + ' \u00b7 ') + fmt(o.s) + '</small></a>';
      list.appendChild(li);
    });
  }

  root.querySelectorAll('[data-unit]').forEach(function (b) {
    b.addEventListener('click', function () {
      var old = unit; unit = b.dataset.unit;
      root.querySelectorAll('[data-unit]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var v = parseFloat(input.value);
      if (v && old !== unit) input.value = unit === 'in' ? Math.round(v / 2.54) : Math.round(v * 2.54);
      update();
    });
  });
  input.addEventListener('input', update);

  fetch(root.dataset.src).then(function (r) { return r.json(); }).then(function (d) {
    data = d; buildChart(); update();
  }).catch(function () { chart.textContent = ''; });
})();
